<template>
  <v-layout row class="ml-2">
    <v-flex>
      {{item.name}} <a :href="item.buy">buy</a>
    </v-flex>
    <v-spacer></v-spacer>
    <v-flex xs2>
      {{costFormatted}}
    </v-flex>
  </v-layout>
</template>

<script>
import utils from '../../../utils.ts'

export default {
  components: {
  },
  props: ['item'],
  data () {
    return {
    }
  },
  computed: {
    costFormatted () {
      return utils.formatCurrency(this.item.cost)
    },
  },
  methods: {
  }
}
</script>

<style scoped>
/* "scoped" attribute limit the CSS to this component only */


</style>
